import { render } from "./MemberDisplay.vue?vue&type=template&id=22efe118&scoped=true"
import script from "./MemberDisplay.vue?vue&type=script&lang=js"
export * from "./MemberDisplay.vue?vue&type=script&lang=js"

import "./MemberDisplay.vue?vue&type=style&index=0&id=22efe118&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22efe118"]])

export default __exports__